<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qwVDDE/tc-custom/9781497656154.jpg?1734036674723" alt="This image is the cover for the book Crystal Gryphon, Witch World: High Hallack Cycle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crystal Gryphon, Witch World: High Hallack Cycle
      </h1>
      <p class="bookDescription body article font2">
        <b>The adventures of Witch World continue as a cursed hero and his true love struggle for survival in a vast parallel universe of magic and high fantasy.</b><br/>  <br/> Kerovan of Ulmsdale has long borne the curse of his ancestors’ depredations. After pillaging a sanctum of the Old Ones, his bloodline has been forever marred by painful sickness and death. Kerovan was born strong and hardy, but he walks on hooves instead of human feet and sees through eyes of amber—just as the Old Ones had.<br/>  <br/> Bound in marriage to the beautiful Joisan of Ithkrypt, Kerovan seeks to claim his rightful place as Lord-heir of Ulmsdale. But first, the couple—separated by distance, yet linked in spirit—must unlock the powers held within a mystical necklace Joisan wears. The small crystal gryphon bears secrets that will bring them to the farthest reaches of the wilderness on a quest to save their people and their world from doom.<br/>  <br/> Science Fiction Writers of America Grand Master Andre Norton’s beloved novels of sword and sorcery have sold millions of copies worldwide.<br/><br/> The Crystal Gryphon <i>is the 3rd book in the Witch World: High Hallack Cycle, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andre Norton
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;For well over a half century, Andre Norton was one of the most popular science fiction and fantasy authors in the world. With series such as Time Traders, Solar Queen, Forerunner, Beast Master, Crosstime, and Janus, as well as many standalone novels, her tales of adventure have drawn countless readers to science fiction. Her fantasy novels, including the bestselling Witch World series, her Magic series, and many other unrelated novels, have been popular with readers for decades. Lauded as a Grand Master by the Science Fiction Writers of America, she is the recipient of a Life Achievement Award from the World Fantasy Convention. An Ohio native, Norton lived for many years in Winter Park, Florida, and died in March 2005 at her home in Murfreesboro, Tennessee.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1948101a